import API_URLS from '../links';

export const getTrainer = (creds,gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_TRAINERS + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token,
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addUpdateTrainer = (creds, formData) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_TRAINER, {
        method: 'POST',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const deleteTrainer = (creds, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_TRAINER + `/${id}`, {
        method: 'DELETE',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updateTrainer = (creds, formData, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_TRAINER + `/${id}`, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
